import { useMutation } from "react-query";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";

export function useConvertToPdf(callbacks?: QueryCallbacks<Response | undefined>) {
  const apiContext = useContext(ApiContext);

  return useMutation({
    mutationKey: ["ConvertToPdf"],
    mutationFn: async (reportDocumentId: number) => {
      return await apiContext.utp2FilesAPIs.convertToPdf(reportDocumentId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
